// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"e4b6e0dd","180":"39df81b2","208":"c4d5c46d","631":"8522638b","774":"33f8e97b","787":"95b0c1cd","820":"5ce26067","910":"f6baf92a"}[chunkId] + ".chunk.js";
};